import React,{useState, useEffect} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
import { v4 as uuidv4 } from 'uuid';
import Swal from 'sweetalert2';
import CommonTooltip from '../../../../../../../../../component/common/CommonTooltip';
const ServiceListTable = (props) => {

    const { 
        service_name, 
        service_synonyms, 
        select_attribute,
        index,
        action_name,
        service_follow_up_details
    } = props;

    let serviceSynonymsHtml = '';
    
    if( service_synonyms.length > 0 ){
        serviceSynonymsHtml = service_synonyms.map((s_synonyms) =>
            <span className="badge badge-light-dark fs-7 fw-bold me-2 text-gray-600"  key={uuidv4()}>
                <span className="text-gray-600 fw-bold fs-6">
                    {s_synonyms.value}
                </span>
            </span>
        )
    }

    const serviceDeleteOnClick = async (index) => {
        const serviceSwal = await Swal.fire({
            title: 'Are you sure?',
            text: 'You won’t be able to revert this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
        });
        if (serviceSwal.isConfirmed) {
            props.serviceDeleteOnClick(index)
        }
    }

    const handleDragStart = (e) => {
        e.dataTransfer.setData('text/plain', index);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const draggedIndex = parseInt(e.dataTransfer.getData('text/plain'), 10);
        props.onDragDrop(draggedIndex, index);
    };

    return(
        <>
            <tr
                draggable
                onDragStart={handleDragStart}
                onDragOver={(e) => e.preventDefault()}
                onDrop={handleDrop}
                style={{
                    cursor: "move",
                }}
            >
                <td
                    data-tooltip-id="common_tooltip" 
                    data-tooltip-content="Drag to rearrange"
                >
                    {service_name}
                </td>
                <td
                    data-tooltip-id="common_tooltip" 
                    data-tooltip-content="Drag to rearrange"
                >
                    {serviceSynonymsHtml}
                </td>
                <td
                    data-tooltip-id="common_tooltip" 
                    data-tooltip-content="Drag to rearrange"
                >
                    {action_name}
                </td> 
                <td
                    data-tooltip-id="common_tooltip" 
                    data-tooltip-content="Drag to rearrange"
                >
                    {service_follow_up_details? service_follow_up_details.label : ''}
                </td> 
                <td className="d-flex float-end" >
                    <div
                        className='cursor-pointer me-3' 
                        onClick={(e) => { e.preventDefault();props.serviceUpdateOnClick(index); }}
                        data-tooltip-id="common_tooltip" 
                        data-tooltip-content="Edit"
                    >
                        <FontAwesomeIcon icon={faPen} className='text-primary fs-3' />
                    </div>
                    <div
                        className='cursor-pointer'
                        onClick={(e) => { e.preventDefault(); serviceDeleteOnClick(index)}} 
                        data-tooltip-id="common_tooltip" 
                        data-tooltip-content="Delete"
                    >
                        <FontAwesomeIcon icon={faTrash} className='text-danger fs-3' />
                    </div>
                </td>
            </tr>
            <CommonTooltip
                id="common_tooltip"
                style= {{ backgroundColor: "black", color: "white", fontSize:"14px" }}
                place="top"
                float={true}
            />
        </>
    )
}

const ServiceList = (props) => {

    const [totalServiceList, setTotalServiceList] = useState([]);
    useEffect(() => {
        if (props.totalServiceList) {
            setTotalServiceList(props.totalServiceList);
        }
    }, [props.totalServiceList]);

    const onDragDropHandler = (draggedIndex, targetIndex) => {
        const updatedList = [...totalServiceList];
        const [draggedItem] = updatedList.splice(draggedIndex, 1);
        updatedList.splice(targetIndex, 0, draggedItem);
        updatedList.forEach((item, newIndex) => {
            item.index = newIndex;
        });
        setTotalServiceList(updatedList);
        props.serviceListOnDrop(updatedList)
    }

    let serviceHtml = '';
    if(totalServiceList.length > 0){
        serviceHtml = totalServiceList.map((service, i) =>
            <ServiceListTable
                key={i}
                index={i}
                service_name={service.service_name}
                service_synonyms={service.service_synonyms}
                action_name={service.action_name}
                service_follow_up_details={service.service_follow_up_details}
                serviceUpdateOnClick={props.serviceUpdateOnClick}
                serviceDeleteOnClick={props.serviceDeleteOnClick}
                onDragDrop={onDragDropHandler}
            />
        )
    }

    return (
        <>
            {
                totalServiceList.length > 0 &&
                <>
                    <div className="separator border-gray-300 my-6"></div>
                    <div className="table-responsive">
                        <table className="table table-row-dashed align-middle gs-0 gy-4">
                            <thead className="border-gray-200 fs-5 fw-semibold bg-lighten">
                                <tr className='fs-7 fw-bold border-0 text-gray-400'>
                                    <th className="">Service</th>
                                    <th className="">Synonyms</th>
                                    <th className="">Action Name</th>
                                    <th className="">Follow up details</th>
                                    <th className=""></th>
                                </tr>
                            </thead>
                            <tbody className="fw-6 fw-semibold text-gray-600">
                                {serviceHtml}
                            </tbody>
                        </table>
                    </div>
                </>
            }
        </>
    )
}

export default ServiceList